/* eslint-disable max-len */

import React from 'react';
import type { SVGProps } from 'react';

export interface NoteProps extends SVGProps<SVGSVGElement> {
  color?: string;
}

export const Note: React.FC<NoteProps> = ({ color = '#171717', ...props }) => {
  return (
    <svg width={20} height={21} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M18.05 8.9113L17.2333 12.3946C16.5333 15.403 15.15 16.6196 12.55 16.3696C12.1333 16.3363 11.6833 16.2613 11.2 16.1446L9.79999 15.8113C6.32499 14.9863 5.24999 13.2696 6.06665 9.78631L6.88332 6.29464C7.04999 5.58631 7.24999 4.96964 7.49999 4.46131C8.47499 2.44464 10.1333 1.90297 12.9167 2.56131L14.3083 2.88631C17.8 3.70297 18.8667 5.42797 18.05 8.9113Z"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.55 16.3696C12.0334 16.7196 11.3834 17.0113 10.5917 17.2696L9.27504 17.703C5.96671 18.7696 4.22504 17.878 3.15004 14.5696L2.08337 11.278C1.01671 7.96964 1.90004 6.21964 5.20837 5.15297L6.52504 4.71964C6.86671 4.6113 7.19171 4.51964 7.50004 4.4613C7.25004 4.96964 7.05004 5.5863 6.88337 6.29464L6.06671 9.7863C5.25004 13.2696 6.32504 14.9863 9.80004 15.8113L11.2 16.1446C11.6834 16.2613 12.1334 16.3363 12.55 16.3696Z"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5334 7.31964L14.5751 8.34464"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.71655 10.5446L12.1332 11.1613"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
